'use client'

import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';

import SlotNumber, { hotnessForMinBet } from '../SlotNumber';


function formatMinBet(minBet: number): string {
    // Whole dollars: "$10". Fractional: "$10.50".
    return Number.isInteger(minBet) ? `$${minBet}` : `$${minBet.toFixed(2)}`;
}

/**
 * This is a React functional component that displays the minimum bet info for casinos.
 * @returns {JSX.Element}
 */
export default function CasinoMinBet({ minBet, minBetType }: { minBet: number | null, minBetType: string }) {
    return (
        <Stack direction={'row'} spacing={1} sx={{ flexGrow: 1, textAlign: "center" }}  >
            <Typography align="center" variant='h6' component="div" sx={{ flexGrow: 1 }}>
                {minBetType}:{' '}
                <SlotNumber
                    value={minBet}
                    format={formatMinBet}
                    emptyText="-"
                    hotness={hotnessForMinBet(minBet)}
                    showFireEmoji
                />
            </Typography>
        </Stack>
    );
}
